import { render, staticRenderFns } from "./BankAccountCreationModal.vue?vue&type=template&id=01f8843d&scoped=true&"
import script from "./BankAccountCreationModal.vue?vue&type=script&lang=js&"
export * from "./BankAccountCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f8843d",
  null
  
)

export default component.exports